import React, { useState, useEffect, useContext } from 'react';
import { Tabla } from 'ui-component';
import headers from './components/Headersasignacion ';
import MainCard from 'ui-component/cards/MainCard';
import LayautContext from 'Context/ContextLayaut';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import { ServiciosAsignacion, FormAsignacion, VistaAsignacion } from './components';

const Asignaciones = ({ permisos }) => {
    const context = useContext(LayautContext);
    const serviciosAsignaciones = ServiciosAsignacion();

    // States
    const [asignacion, setAsignacion] = useState([]);
    const [ctl, setCtl] = useState({ estatusAsignacion: [], cursos: [], grupos: [] });
    const [confirm, setConfirm] = useState({ open: false });

    // Handle
    const actualizarData = (nuevaAsignacion = []) => {
        const nuevasAsignacionesProcesadas = procesarAsignaciones(nuevaAsignacion);
        const dataAsignacion = asignacion.map((oc) => oc.idAsignacion);
        nuevasAsignacionesProcesadas.forEach((asignacionI) => {
            const indice = dataAsignacion.indexOf(asignacionI.idAsignacion);
            if (indice >= 0) asignacion.splice(indice, 1, asignacionI);
            else asignacion.splice(0, 0, asignacionI);
        });
        setAsignacion([...asignacion]);
    };

    // Función para formatear fechas para búsqueda
    const formatearFechaParaBusqueda = (fechaStr) => {
        if (!fechaStr) return '';

        const partes = fechaStr.split(/[- :]/);
        const fecha = new Date(partes[0], partes[1] - 1, partes[2], partes[3] || 0, partes[4] || 0, partes[5] || 0);

        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const año = fecha.getFullYear();
        let horas = fecha.getHours();
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const ampm = horas >= 12 ? 'PM' : 'AM';

        horas = horas % 12;
        horas = horas ? horas : 12;

        const fechaSola = `${dia}-${mes}-${año}`;
        const horaSola = `${String(horas).padStart(2, '0')}:${minutos} ${ampm}`;

        return {
            completa: `${fechaSola} ${horaSola}`,
            fecha: fechaSola,
            hora: horaSola
        };
    };

    // Procesar datos para agregar campos formateados
    // Procesar datos para agregar campos formateados
    const procesarAsignaciones = (datos) => {
        return datos.map((item) => {
            const fechaInicio = formatearFechaParaBusqueda(item.fechaInicioCurso);
            const fechaFin = formatearFechaParaBusqueda(item.fechaFinCurso);
            const fechaCreacion = formatearFechaParaBusqueda(item.fechaCreacion);
            const fechaModificacion = formatearFechaParaBusqueda(item.fechaModificacion);

            return {
                ...item,
                fechaInicioFormateada: fechaInicio.fecha,
                fechaInicioCompleta: fechaInicio.completa,
                fechaFinFormateada: fechaFin.fecha,
                fechaFinCompleta: fechaFin.completa,
                fechaCreacionFormateada: fechaCreacion.fecha,
                fechaCreacionCompleta: fechaCreacion.completa,
                fechaModificacionFormateada: fechaModificacion.fecha,
                fechaModificacionCompleta: fechaModificacion.completa
            };
        });
    };

    const abrirVerAsignacion = (row) => {
        context.formulario.abrir({
            open: true,
            titulo: 'Detalle de Asignación',
            propsForm: { data: row },
            formulario: VistaAsignacion,
            isVer: true,
            aceptar: () => {}
        });
    };

    const abrirEditarAsignacion = (row) => {
        context.formulario.abrir({
            open: true,
            titulo: 'Editar Asignación',
            propsForm: { data: row, ctl: ctl },
            formulario: FormAsignacion,
            aceptar: (dataForm) => {
                serviciosAsignaciones.updateAsignacion(
                    (res) => {
                        actualizarData(res.asignacion);
                        context.formulario.cerrar();
                    },
                    { idAsignacion: row.idAsignacion, ...dataForm }
                );
            }
        });
    };

    const abrirConfirmarCambio = (asignacion) => (e) => {
        let texto = `¿Estás seguro de volver a activar la asignación del curso "${asignacion.nombreCurso}" al grupo "${asignacion.nombreGrupo}"?`;
        let status = 1;
        if (asignacion.estatus === '1') {
            texto = `¿Estás seguro de desactivar la asignación del curso "${asignacion.nombreCurso}" al grupo "${asignacion.nombreGrupo}"?`;
            status = 0;
        }
        setConfirm({
            open: true,
            text: texto,
            aceptar: () =>
                serviciosAsignaciones.cambiarEstatusAsignacion(
                    (nuevaData) => {
                        actualizarData(nuevaData.asignacion);
                        setConfirm({ open: false });
                    },
                    { ids: asignacion.idAsignacion, estatus: status }
                )
        });
    };

    // Config
    const accionesFila = [
        { label: 'Ver', onClick: abrirVerAsignacion, enabled: true },
        { label: 'Editar', onClick: abrirEditarAsignacion, enabled: true }
    ];

    useEffect(() => {
        serviciosAsignaciones.getAsignacionesInt((ct) => {
            const asignacionesProcesadas = procesarAsignaciones(ct.asignacion || []);
            setAsignacion(asignacionesProcesadas);
            setCtl({
                estatusAsignacion: ct.estatusAsignacion || [],
                cursos: ct.cursos || [],
                grupos: ct.grupos || []
            });
        });
    }, []);

    return (
        <MainCard title="Asignaciones de Cursos">
            <Tabla
                rows={asignacion}
                columns={headers(abrirConfirmarCambio, ctl).asignacion}
                accionesFila={accionesFila}
                columnKey="idAsignacion"
            />
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
        </MainCard>
    );
};

export default Asignaciones;
